import { cn } from "@/utils/cn";
import { memo } from "react";

interface ChatIconSquareProps {
  className?: string;
}

export const ChatIconSquare = memo(function ChatIconSquare({ className }: ChatIconSquareProps) {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
    >
      <path
        d="M18 0H1.50003C1.1022 0 0.72067 0.158035 0.439366 0.43934C0.158061 0.720644 2.61181e-05 1.10218 2.61181e-05 1.5V16.5C-0.00166874 16.7859 0.079157 17.0662 0.232808 17.3074C0.386459 17.5485 0.60641 17.7401 0.866276 17.8594C1.06486 17.9516 1.28109 17.9996 1.50003 18C1.85215 17.9992 2.1926 17.8736 2.46096 17.6456L2.4694 17.6391L5.53128 15H18C18.3979 15 18.7794 14.842 19.0607 14.5607C19.342 14.2794 19.5 13.8978 19.5 13.5V1.5C19.5 1.10218 19.342 0.720644 19.0607 0.43934C18.7794 0.158035 18.3979 0 18 0ZM18 13.5H5.25003C5.06994 13.5001 4.8959 13.565 4.75971 13.6828L1.50003 16.5V1.5H18V13.5ZM6.00003 6C6.00003 5.80109 6.07904 5.61032 6.2197 5.46967C6.36035 5.32902 6.55111 5.25 6.75003 5.25H12.75C12.9489 5.25 13.1397 5.32902 13.2804 5.46967C13.421 5.61032 13.5 5.80109 13.5 6C13.5 6.19891 13.421 6.38968 13.2804 6.53033C13.1397 6.67098 12.9489 6.75 12.75 6.75H6.75003C6.55111 6.75 6.36035 6.67098 6.2197 6.53033C6.07904 6.38968 6.00003 6.19891 6.00003 6ZM6.00003 9C6.00003 8.80109 6.07904 8.61032 6.2197 8.46967C6.36035 8.32902 6.55111 8.25 6.75003 8.25H12.75C12.9489 8.25 13.1397 8.32902 13.2804 8.46967C13.421 8.61032 13.5 8.80109 13.5 9C13.5 9.19891 13.421 9.38968 13.2804 9.53033C13.1397 9.67098 12.9489 9.75 12.75 9.75H6.75003C6.55111 9.75 6.36035 9.67098 6.2197 9.53033C6.07904 9.38968 6.00003 9.19891 6.00003 9Z"
        fill="#620AD5"
      />
    </svg>
  );
});
